import { Fragment, type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { tracking } from "shared/data";

import type { trendingTopicHomeV2Topic$key } from "scmp-app/queries/__generated__/trendingTopicHomeV2Topic.graphql";

import { Container, Separator, StyledEntityLink, Title, Topics } from "./styles";

type Props = {
  className?: string;
  reference: trendingTopicHomeV2Topic$key;
};

export const HomeV2TrendingTopic: FunctionComponent<Props> = ({ className, reference }) => {
  const data = useFragment(
    graphql`
      fragment trendingTopicHomeV2Topic on Query
      @argumentDefinitions(trendingTopicsQueueName: { type: "String!" }) {
        trendingTopicsV2Queue: queue(filter: { name: $trendingTopicsQueueName }) {
          items(first: 7) {
            edges {
              node {
                ... on Topic {
                  ...entityLink
                  name
                  entityId
                }
              }
            }
          }
        }
      }
    `,
    reference,
  );

  const edges = data.trendingTopicsV2Queue?.items?.edges ?? [];

  if (edges.length === 0) return null;

  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: tracking.module.TrendingTopics,
      }}
    >
      <Container className={className}>
        <Title>TRENDING TOPICS</Title>
        <Topics>
          {edges.map(({ node }, index) => (
            <Fragment key={node.entityId}>
              {index > 0 && <Separator aria-hidden="true">|</Separator>}
              <StyledEntityLink reference={node}>{node.name}</StyledEntityLink>
            </Fragment>
          ))}
        </Topics>
      </Container>
    </BaseLinkContextProvider>
  );
};

HomeV2TrendingTopic.displayName = "HomeV2TrendingTopic";
